export default __webpack_public_path__ + "static/ok-31a9ffbd0f3fc5384e973b5c70c70269.gif";